//@import dependencies
import React, {useState, useEffect} from 'react'
//@end

//@import components
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import CourseSchedulingScreenFormFilterLayout from 'app_components/screens/admin/courseScheduling/components/courseSchedulingScreenFormFilterLayout'
import PaginationCommon from 'app_components/commons/pagination'
import AlertComponent from 'app_components/commons/alert'
//@end

// @import hooks
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
// @end

// @INFO Import types
import { ICourseSchedulingListItem } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
// @end

// @INFO Import services
import CourseSchedulingService from 'app_services/admin/courseScheduling/courseSchedulingService'
import TimeService from 'app_services/time/timeService'
// @end

// @import events
import { CombinedReducers } from 'app_events/index';
// @end events

// @INFO Import Styles
import './../myClientsModule.scss'
import ModalAttached from 'app_components/modules/ModalAttached/ModalAttached'
import TooltipComponent from 'app_components/commons/TooltipComponent/TooltipComponent'
import { HiDocumentReport } from 'react-icons/hi'
import { AiOutlineCloudDownload } from 'react-icons/ai'

// @ADD Component types
interface IMyClientsModuleLayoutProps {}

interface Paginator{
  page: number
  perPage: number
  total: number
}

type TypeStatusPage = 'not_loaded' | 'not_found' | 'success' | 'error' | 'loading';

const MyClientsModuleLayout: React.FC<IMyClientsModuleLayoutProps> = (props) => {

  const { t } = useTranslation()
  const searchForm = useForm();
  const [paginator, updatePaginator] = useState<Paginator>({
    page: 1,
    perPage: 10,
    total: 0
  });
  const [dataSearch, updateDataSearch] = useState<any>();
  const [items, updateItems] = useState<ICourseSchedulingListItem[]>([]);
  const user = useSelector((store: CombinedReducers) => store.auth?.user);
  const [status, updateStatus] = useState<TypeStatusPage>('not_loaded');
  const [openBusinessReport, updateOpenBusinessReport] = useState<ICourseSchedulingListItem | undefined>(undefined);
  const [openPartialReport, updateOpenPartialReport] = useState<any | undefined>(undefined);

  const courseSchedulingService = new CourseSchedulingService()
  const timeService = new TimeService();

  useEffect(() => {
    handleOnSearch();
  }, [])

  useEffect(() => {
    if (paginator.page > 1) {
      handleOnSearch()
    }
  }, [paginator.page])

  const handleOnSearch = async (data?: any) => {
    updateStatus('loading');
    const response = await courseSchedulingService.getListWithFilter({
      ...data ? data : dataSearch,
      page: data ? 1 : paginator.page,
      perPage: paginator.perPage,
      account_executive: user?.data?.id
    });
    // Actualizar el paginador y guardar los items si llega una respuesta exitosa
    if (response?.pagination) {
      updatePaginator(response?.pagination)
      updateItems(response.itemList);
      if (response.itemList?.length) {
        updateStatus('success');
      } else{
        updateStatus('not_found');
      }
    } else {
      updateStatus('error')
    }
    // Guardar los datos del formulario para poder cambiar de pagina
    updateDataSearch(data);
  }

  const handleChangePage = (newPage: number) => {
    updatePaginator({
      ...paginator,
      page: newPage
    })
  }

  const handleClickBusinessReport = (courseScheduling: any) => {
    updateOpenBusinessReport(courseScheduling);
  }

  const handleClickPartialReport = (courseScheduling: any) => {
    updateOpenPartialReport(courseScheduling);
  }

  const handleClearFilter = () => {
    searchForm.reset()
    handleOnSearch({})
  }

  return(
    <div className='my_clients-layout'>
      <TextComponent
        type='subtitle'
        className='title-module'
      >
        Mis clientes
      </TextComponent>
      <CourseSchedulingScreenFormFilterLayout
        searchForm={searchForm}
        onSearch={handleOnSearch as any}
        className='form-search-module'
        fields={['companies_executive', 'start_date', 'end_date']}
        executiveId={user?.data?.id}
        onClear={handleClearFilter}
      />
      {items?.length ?
      <div className="container-table-module">
        <table>
          <thead>
            <tr>
              <th>Identificador del servicio</th>
              <th>Código del programa</th>
              <th>Curso/Programa/Diplomado</th>
              <th>Modular</th>
              <th>Modalidad</th>
              <th>Empresa</th>
              <th>Horas</th>
              <th>Estado</th>
              <th>Fecha Inicio</th>
              <th>Fecha Fin</th>
              <th>Persona de contacto</th>
              <th>Informes</th>
            </tr>
          </thead>
          <tbody>
            {items?.map((item) => (
              <tr
                key={item._id}
              >
                <td>{item.metadata?.service_id}</td>
                <td>{item.program?.code}</td>
                <td>{item.program?.name}</td>
                <td>{item.modular?.name}</td>
                <td>{item.schedulingType?.name}</td>
                <td>{item.client?.name}</td>
                <td>{timeService.secondsFormatHMS(item?.duration || 0, 'HHh')}</td>
                <td>{item.schedulingStatus?.name}</td>
                <td>{item.startDate}</td>
                <td>{item.endDate}</td>
                <td>{`${item.contact?.profile?.first_name || ''} ${item.contact?.profile?.last_name || ''}`}</td>
                <td>
                  <div style={{
                    display: 'flex',
                    gap: '10px',
                    justifyContent: 'center',
                    width: '100%'
                  }}>
                    {item?.business_report ?
                      <TooltipComponent
                        text='Informe empresarial final'
                        className='tooltip-icon-scheduling-screen'
                      >
                        <AiOutlineCloudDownload
                          onClick={() => handleClickBusinessReport(item)}
                          className='icon-scheduling-screen'
                        />
                      </TooltipComponent>
                    :null}
                    {item?.partial_report ?
                      <TooltipComponent
                        text='Informe empresarial parcial'
                        className='tooltip-icon-scheduling-screen'
                      >
                        <AiOutlineCloudDownload
                          onClick={() => handleClickPartialReport(item)}
                          className='icon-scheduling-screen'
                        />
                      </TooltipComponent>
                    :null}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      :null}
      {items?.length ?
        <PaginationCommon
          data={paginator}
          onChangePage={handleChangePage}
        />
      :null}
      <ModalAttached
        open={openBusinessReport !== undefined}
        onClose={() => updateOpenBusinessReport(undefined)}
        defaultValue={openBusinessReport?.business_report}
        title="Informe empresarial final"
        category='business_report'
        disabled
      />
      <ModalAttached
        open={openPartialReport !== undefined}
        onClose={() => updateOpenPartialReport(undefined)}
        defaultValue={openPartialReport?.partial_report}
        title="Informe empresarial parcial"
        category='partial_report'
        disabled
      />
      {status === 'not_found' ?
        <AlertComponent description='No se han encontrado elementos' type='info' />
      : null}
    </div>
  )
}

export default MyClientsModuleLayout
